<template>
  <div>
    <!-- 查询输入框 -->
    <div>
      <el-row gutter="10">
        <!-- 设备ID输入框 -->
        <el-col :span="6">
          <el-input
              placeholder="请输入设备ID"
              v-model="searchParams.deviceId"
              clearable
          >
          </el-input>
        </el-col>

        <!-- 检测员ID输入框 -->
        <el-col :span="6">
          <el-input
              placeholder="请输入检测员ID"
              v-model="searchParams.inspectorId"
              clearable
          >
          </el-input>
        </el-col>

        <!-- 选择开始时间 -->
        <el-col :span="6">
          <el-date-picker
              v-model="searchParams.begin"
              type="date"
              placeholder="开始日期"
              :picker-options="pickerOptions"
              clearable
          >
          </el-date-picker>
        </el-col>

        <!-- 选择结束时间 -->
        <el-col :span="6">
          <el-date-picker
              v-model="searchParams.end"
              type="date"
              placeholder="结束日期"
              :picker-options="pickerOptions"
              clearable
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <br>
      <!-- 查询按钮，在下一行 -->
      <div class="block">
        <el-button type="primary" @click="searchDeviceLog">查询日志数据</el-button>
        <el-button type="success" @click="exportWaterData" :disabled="!deviceLogData || deviceLogData.length === 0">
          导出日志数据
        </el-button>
      </div>
    </div>
    <br>

    <!-- 设备日志列表 -->
    <el-table
        :data="deviceLogData"
        style="width: 100%; table-layout: auto;"
        :row-class-name="tableRowClassName"
        :header-cell-style="{textAlign: 'center', whiteSpace: 'nowrap'}"
        :cell-style="{textAlign: 'center', whiteSpace: 'nowrap'}"
    >
      <el-table-column prop="id" label="ID" min-width="50" max-width="120"></el-table-column>
      <el-table-column prop="deviceId" label="设备ID" min-width="50" max-width="200"></el-table-column>
      <el-table-column prop="logType" label="日志类型" min-width="50" max-width="120"></el-table-column>
      <el-table-column prop="logData" label="日志内容" min-width="50" max-width="200">
        <template #default="scope">
          <div v-if="scope && scope.row && scope.row.logData">
            {{ scope.row.logData }}
          </div>
          <div v-else class="text-gray-400">无内容</div>
        </template>
      </el-table-column>
      <el-table-column prop="logTime" label="日志时间" min-width="50" max-width="220"></el-table-column>
    </el-table>

    <br><br>
    <!-- 分页控制 -->
    <div class="block">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageParams.total"
          :current-page="pageParams.current"
          :page-size="pageParams.pageSize"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {exportLogData, fetchDeviceLogData} from "@/api/deviceLog";
import {ElMessage} from "element-plus";
import { API_BASE_URL } from '@/config';

export default {
  data() {
    return {
      searchParams: {
        deviceId: "", // 设备ID
        inspectorId: "", // 检测员ID
        begin: "", // 开始时间
        end: "", // 结束时间
      },
      deviceLogData: [],
      pageParams: {
        current: 1, // 当前页
        pageSize: 10, // 每页大小
        total: 0, // 总记录数
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    hasMorePages() {
      return this.pageParams.current * this.pageParams.pageSize < this.pageParams.total;
    },
  },
  methods: {
    exportLogData,
    handleSizeChange(val) {
      this.pageParams.pageSize = val;
      this.pageParams.current = 1; // 切换每页数量时回到第一页
      this.searchDeviceLog();
    },

    handleCurrentChange(val) {
      this.pageParams.current = val;
      this.searchDeviceLog();
    },

    async searchDeviceLog() {
      // 验证设备ID或检测员ID至少有一个不为空
      if (!this.searchParams.deviceId && !this.searchParams.inspectorId) {
        this.$message.warning("设备ID和检测员ID至少传入一个");
        return;
      }

      // 检查开始日期是否晚于结束日期
      if (this.searchParams.begin && this.searchParams.end) {
        const beginDate = new Date(this.searchParams.begin);
        const endDate = new Date(this.searchParams.end);
        if (beginDate > endDate) {
          this.$message.warning("开始日期不能晚于结束日期");
          return;
        }
      }

      // 构建请求参数
      const requestData = {
        current: this.pageParams.current, // 传递当前页
        pageSize: this.pageParams.pageSize, // 传递每页数量
      };

      // 如果选择了设备ID，添加到请求参数
      if (this.searchParams.deviceId) {
        requestData.deviceId = this.searchParams.deviceId;
      }

      // 如果选择了检测员ID，添加到请求参数
      if (this.searchParams.inspectorId) {
        requestData.inspectorId = this.searchParams.inspectorId;
      }

      // 如果选择了开始日期，添加到请求参数
      if (this.searchParams.begin) {
        requestData.begin = this.searchParams.begin;
      }

      // 如果选择了结束日期，添加到请求参数
      if (this.searchParams.end) {
        requestData.end = this.searchParams.end;
      }

      try {
        const response = await fetchDeviceLogData(requestData);

        if (response.data && response.data.records) {
          // 保存原始的总记录数
          this.pageParams.total = response.data.total;

          // 处理日志时间过滤
          let filteredRecords = response.data.records;

          // 如果设置了开始日期，过滤早于开始日期的日志
          if (this.searchParams.begin) {
            const beginDate = new Date(this.searchParams.begin);
            filteredRecords = filteredRecords.filter(record => {
              const logDate = new Date(this.formatTimestamp(record.timestamp));
              return logDate >= beginDate;
            });
          }

          // 如果设置了结束日期，过滤晚于结束日期的日志
          if (this.searchParams.end) {
            const endDate = new Date(this.searchParams.end);
            // 设置结束日期的时间为23:59:59，以便包含当天所有时间
            endDate.setHours(23, 59, 59, 999);
            filteredRecords = filteredRecords.filter(record => {
              const logDate = new Date(this.formatTimestamp(record.timestamp));
              return logDate <= endDate;
            });
          }

          // 应用过滤后的记录
          this.deviceLogData = filteredRecords.map((item) => ({
            ...item,
            logTime: this.formatTimestamp(item.timestamp),
            logData: item.logData,
          }));

          // 如果查询结果为空，提示用户
          if (filteredRecords.length === 0) {
            this.$message.info("未查询到符合条件的日志数据");
          }
        } else {
          this.$message.info("未查询到日志数据");
          this.deviceLogData = [];
          this.pageParams.total = 0;
        }
      } catch (error) {
        console.error("查询日志数据失败:", error);
        this.$message.error("查询数据失败，请稍后再试");
      }
    },

    // 导出日志数据
    async exportWaterData() {
      // 校验：必须有查询结果才能导出
      if (!this.deviceLogData || this.deviceLogData.length === 0) {
        ElMessage.warning("没有数据可导出，请先查询数据");
        return;
      }

      // 准备导出参数（使用当前查询条件）
      const exportParams = {
        deviceId: this.searchParams.deviceId,
        inspectorId: this.searchParams.inspectorId,
        begin: this.searchParams.begin,
        end: this.searchParams.end,
        // 导出全部数据，不使用分页（根据后端接口调整）
        // 注意：如果后端接口不支持不分页，可能需要调整为获取所有页数据
        pageSize: this.pageParams.total > 10000 ? 10000 : this.pageParams.total // 限制最大导出数量
      };

      try {
        // 显示加载状态
        ElMessage.info("正在准备数据，请稍候...");

        // 调用导出API（使用已有的exportWaterData函数）
        // const response = await exportWaterData(exportParams);

        console.log("@@@@@@@@@@@@@@@@token："+localStorage.getItem('token'));
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE_URL}/api/web/devicelog/export`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'token': token, // 使用后端期望的 token 头
          },
          body: JSON.stringify(exportParams),
          responseType: 'blob', // 关键配置：告知浏览器接收二进制流
        });

        // 创建Blob对象
        // const blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        // 关键步骤：通过 response.blob() 获取 Blob 对象
        //处理Blob响应
        const blob = await response.blob();
        // console.log('@@@@@@@@@blob类型:', blob instanceof Blob); // 应输出 true
        // console.log('@@@@@@@@@blob.size:', blob.size); // 应显示正确大小
        // 创建下载链接
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);

        // 设置文件名（包含时间戳，避免重复）
        const date = new Date();
        const formattedDate = date.getFullYear() +
            String(date.getMonth() + 1).padStart(2, '0') +
            String(date.getDate()).padStart(2, '0') + '_' +
            String(date.getHours()).padStart(2, '0') +
            String(date.getMinutes()).padStart(2, '0') +
            String(date.getSeconds()).padStart(2, '0');
        link.download = `日志数据_${formattedDate}.xlsx`;

        // 触发下载
        document.body.appendChild(link);
        link.click();

        // 清理资源
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);

        ElMessage.success("导出成功");
      } catch (error) {
        //错误处理
        console.error("导出失败:", error);

        // 处理可能的HTTP错误
        if (error.response) {
          if (error.response.status === 401) {
            ElMessage.error("登录状态已过期，请重新登录");
            this.$router.push({name: 'Login'});
            return;
          } else if (error.response.status === 403) {
            ElMessage.error("没有导出权限");
            return;
          }
        }

        ElMessage.error("导出失败，请稍后再试");
      }
    },

    // 时间戳转北京时间函数（处理毫秒级时间戳）
    formatTimestamp(timestamp) {
      if (!timestamp) return "";
      let date;
      if (typeof timestamp === "number") {
        // 秒级时间戳（< 1e12）转为毫秒，毫秒级直接用
        date = new Date(timestamp < 1e12 ? timestamp * 1000 : timestamp);
      } else {
        // 字符串格式（ISO-8601 等）直接用 Date 解析
        date = new Date(timestamp);
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<style>
.text-gray-400 {
  color: #9CA3AF;
}
/* 新增：确保表格内容不换行 */
.el-table td, .el-table th {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
</style>
